import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import { Chart, Series, CommonSeriesSettings, Legend, ArgumentAxis, Label, Animation, Tooltip, Grid, CommonAxisSettings } from 'devextreme-react/chart';
import WidgetSettings from "./widgetSettings";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";

function CallsByGroup(props) {

    const { t } = useTranslation();
    const [groups, setGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/callsbygroup", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("callsbygroup");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`CallsByGroup_groups_${props.identifier}_user${props.id}`) || "[]");
            setSelectedGroups(selectedGroups);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/callsbygroup/`, function (callsbygroup) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    setGroups(data);
                }
            }, { id: "callsbygroup" });

            MonitorWSService.stompClient.send("/app/subscribe/callsbygroup", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const customizeTooltip = (arg) => {
        return {
            text: `${arg.seriesName}: ${arg.valueText}`,
        };
    }
    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const selectGroups = (groups) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`CallsByGroup_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));
        MonitorWSService.stompClient.send("/app/subscribe/callsbygroup", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups
        }));

    };



    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-simple")} /> {t("callsbygroup")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "100%" }}>
                <Chart
                    id="chart"
                    dataSource={groups}
                    height={"345px"}
                    rtlEnabled={props.rtl}

                >
                    <CommonAxisSettings>
                        <Grid visible={false} />
                    </CommonAxisSettings>
                    <CommonSeriesSettings argumentField="groupName" type="bar" barWidth={30} barPadding={0.2} />
                    <Series
                        valueField="missedCalls"
                        name={t("missed")}
                        color={"#f1416c"}
                        cornerRadius={5}

                    />
                    <Series
                        valueField="answeredCalls"
                        name={t("attended")}
                        color={"#50cd89"}
                        cornerRadius={5}
                    />
                    <ArgumentAxis>
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        />
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                        itemTextPosition="top"
                    />
                    <Animation
                        enabled={false}
                    />
                    <Tooltip
                        enabled={true}
                        location="edge"
                        customizeTooltip={customizeTooltip}
                    />
                </Chart>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroups={selectGroups} groups={selectedGroups} selectionType={selectionTypes.GROUPMULTIPLE}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(CallsByGroup);